
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { Provider } from '~/core/offer.types'

@Component
export default class ProvidersListStatic extends Vue {
  @Prop({ required: true, default: () => [], type: Array })
  readonly providers!: Provider[]
}
